import { render, staticRenderFns } from "./emptyStateCore.vue?vue&type=template&id=62612121"
import script from "./emptyStateCore.vue?vue&type=script&lang=js"
export * from "./emptyStateCore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports